import * as actions from "store/actions/company/detail";
import IUser from "Types/IMei";
import ISplit from "Types/Split";

export interface CompanyDetailState {
	item: IUser;
	splits: ISplit[];
	loading: { get: boolean };
	errors: any;
}

interface MyAction {
	type: string;
	payload: any;
}

const initialState: CompanyDetailState = {
	item: {},
	splits: [],
	loading: { get: false },
	errors: {}
};

const reducer = function (state = initialState, action: MyAction) {
	const { type, payload } = action;
	switch (type) {
		case actions.GET_COMPANY: {
			return {
				...state,
				loading: { ...state.loading, get: true },
				errors: initialState.errors
			};
		}
		case actions.GET_COMPANY_SUCCESS: {
			return {
				...state,
				loading: { ...state.loading, get: false },
				item: payload
			};
		}
		case actions.GET_COMPANY_FAILED: {
			return {
				...state,
				loading: { ...state.loading, get: false },
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
